import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import { Site } from 'graphql-api/gql-api-interfaces';

@Component({
  selector: 'epc-brand-org-text-or-logo',
  templateUrl: './brand-org-text-or-logo.component.html',
  styleUrls: ['./brand-org-text-or-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BrandOrgTextOrLogoComponent {
  public imageMaxSizes = IMAGE_MAX_SIZES;

  @Input()
  public site: Site;

  @Input()
  public selected = false;
}
